import { useState } from "react";
import Slider from "react-slick";
import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Service/DynamicImage";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";


const ImageSlider = () => {
  const { productItem } = useAppSelector((state) => state.product);

  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();

  return (
      <Col xl="4" md="6" className="box-col-12">
        <Card>
          <CardBody className="p-2 ecommerce-slider">
            <Slider autoplay speed={3000} arrows={false} asNavFor={nav2} ref={(slider1:any) => setNav1(slider1)}>
              {productItem ? productItem.map((item) => item.variants.map((items, id) => <Image src={`${dynamicImage(items.images)}`} alt="" className="rounded-4 p-2" height="400px" key={id} />)) : "No product Found "}
            </Slider>
            <Slider arrows={false} asNavFor={nav1} ref={(slider2:any) => setNav2(slider2)} slidesToShow={4} swipeToSlide={true} focusOnSelect={true}>
              {productItem &&
                productItem.map((item) => {
                  return item.variants.map((items, id) => <Image src={`${dynamicImage(items.images)}`} alt={"img"} height="140px" className=" img-fluid rounded-4 p-2" key={id} />);
                })}
            </Slider>
          </CardBody>
        </Card>
      </Col>
  );
};
export default ImageSlider;
